<template>

  <b-modal
    :id="'index-devis-modal-' + this.operationHonoraire.id"
    :ok-title="$t('Add')"
    :title="$t('Devis') + ' : ' + operationHonoraireName"
    centered
    ok-only
    ok-variant="primary"
    @ok="handleAdd">

    <template v-for="(item, index) in operationHonoraire.devis">
      <div class="row mr-1 ml-1">
        <b-link class="underline-text" v-on:click="editDevis(index)"><b>{{ item.artisan.toString }}</b><span
          v-if="item.numero"> - N°{{ item.numero }}</span></b-link>
        <div class="ml-auto">
          {{ item.prixTTC }}€ TTC
        </div>
      </div>
      <div class="row mr-1 ml-1">
        <div v-if="item.documents && item.documents.length === 1">
          {{ item.documents.length }} {{ $t("document.associe") }}
        </div>
        <div v-if="item.documents && item.documents.length > 1">
          {{ item.documents.length }} {{ $t("document.associes") }}
        </div>
        <div v-if="item.validated" class="ml-auto validated">
          {{ $t("devis.validated") }}
        </div>
      </div>
      <hr class="devis-hr"/>
    </template>

  </b-modal>

</template>

<script>

import AutoCompleteObjectField from "../../../components/b122/editFields/AutoCompleteObjectField.vue";

export default {

  name: "IndexDevisHonoraireModal",

  components: {
    AutoCompleteObjectField
  },

  props: {
    operationHonoraireName: "",
    operationHonoraire: {
      type: Object,
      default: null
    }
  },

  data() {
    return {}
  },

  emits: ['didAddDevis', 'didEditDevis'],

  async mounted() {
  },

  methods: {

    handleAdd() {
      this.$emit('didAddDevis')
      this.hideModal()
    },

    editDevis(index) {
      this.$emit('didEditDevis', index)
      this.hideModal()
    },

    hideModal() {
      this.$bvModal.hide('index-devis-modal')
    },
  }

}

</script>

<style scoped>
.devis-hr {
  border-top: 2px solid #E0E0E0;
}

.validated {
  color: var(--main-green);
}
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/IndexDevisHonoraireModal.vue